import PluginConfiguration from "./PluginConfiguration";
import PluginItemView from "./PluginItemView";

export default {
    pluginTypeId: 'email',
    pluginTypeName: 'Email Client',
    PluginConfiguration: PluginConfiguration,
    PluginItemView: PluginItemView
}



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/index.js